import React, { Component } from 'react';
import { getMonthYearString } from '../Utilities/JsonFunctions.js'
import FormExplanationValidation from './FormExplanationValidation.js';
declare var $;

class FormMonthPicker extends Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
        this.onKeyPress = this.onKeyPress.bind(this);
    }

    componentDidMount() {
        var _this = this;

        this.$check = $(this.check);
        this.$check.prop("checked", (this.props.value == null || this.props.value.length === 0));

        this.$el = $(this.el);
        this.$el.val(this.props.value);
        this.$el.prop("disabled", this.$check.prop("checked"));
        this.$el.datepicker({
            changeMonth: true,
            changeYear: true,
            yearRange: "c-70:c+10",
            showAnim: "",
            dateFormat: "mm/yy",
            onClose: function(dateText, inst) { 
                $('#ui-datepicker-div').removeClass("month-picker");

                var date = _this.getDateFromMonthString(inst.input.val());
                if (date != null) {
                    $(this).datepicker('setDate', date);
                }

                var e = {
                    target: this
                }
                _this.handleChange(e)
            },
            onChangeMonthYear: function(year, month, inst) {
                var monthString = "00".substring(0, 2 - month.toString().length) + month
                inst.input.val(monthString + "/" + year);
            },            
            beforeShow: function(input, inst) {
                var date;

                if (inst.selectedYear > 0) {
                    date = new Date(inst.selectedYear, inst.selectedMonth, 1);
                    $(this).datepicker("option", "defaultDate", date);
                } else {
                    // first time: date now
                    date = new Date();
                }

                inst.input.val(getMonthYearString(date));
                
                $('#ui-datepicker-div').addClass("month-picker");
            },
            afterShow: function() {
                $("#ui-datepicker-div, #ui-datepicker-div *[class^='ui-']").each(function(i, elm ) {
                    var css = elm.className.split(/\s+/);
                    for (var iCss = 0; iCss < css.length; iCss++) {
                        if (css[iCss].match("^ui-")) {
                            $(elm).addClass("datetime-" + css[iCss]);
                        }
                    }
                });                                     
            },
            onSelect: function() {
                var e = {
                    target: this
                }
                _this.handleChange(e);
            }
        });
    }

    componentWillUnmount() {
        this.$el.datepicker("destroy");
    }     

    componentDidUpdate() {
        this.$check.prop("checked", (this.props.value == null || this.props.value.length === 0));
        this.$el.val(this.props.value);
        this.$el.prop("disabled", this.$check.prop("checked"));

        var date = this.getDateFromMonthString(this.props.value);
        if (date == null) {
            return;
        }

        this.$el.datepicker('setDate', date);
    }

    handleChange(e) {
        this.props.onMonthChange(e.target.value);
    }

    handleCheckboxChange(e) {
        var checked = this.$check.prop("checked");

        this.$el.prop("disabled", checked);

        if (checked) {
            this.$el.val("");
            this.props.onMonthChange("");
        } else {
            this.$el.focus();
        }
    }

    onKeyPress(e) {
        if (e.key === "Enter") {
            e.preventDefault();
            
            if (this.props.onEnter == null) {
                return;
            }
            this.props.onEnter(e);
        }
    }

    getDateFromMonthString(monthString) {
        var dateValues = monthString.split("/");
        if (dateValues.length !== 2) {
            return null;
        }

        var month = dateValues[0] - 1;
        var year = dateValues[1];

        return new Date(year, month, 1);
    }

    render() {

        let requiredMark = this.props.required ? <span className="required-mark">*</span> : null;

        return (
            <div className="tr">
                <div className="FieldLabel td">
                    <label htmlFor={this.props.id}>{this.props.text}
                        {requiredMark}
                    </label>
                </div>
                <div className="EditingFormValueCell td">
                    <div className="date-time-picker month-picker">
                        <div className="control-group-inline">
                            <input type="text" ref={el => this.el = el} id={this.props.id}
                                maxLength="7" onKeyPress={this.onKeyPress}
                                className="form-control CalendarTextBox" />
                            {
                                (this.props.showCheckbox) ?
                                    <span className="checkbox"><input type="checkbox" id={this.props.id + "Check"} ref={check => this.check = check} onClick={this.handleCheckboxChange} /><label htmlFor={this.props.id + "Check"}>{this.props.textCheckbox}</label></span> :
                                    ""
                            }                            
                        </div>
                    </div>
                    <FormExplanationValidation id={this.props.id} explanation={this.props.explanation} showValidation={this.props.showValidation} validationText={this.props.validationText} />
                </div>
            </div>
        );
    }
}

export default FormMonthPicker;


// WEBPACK FOOTER //
// ./src/Fields/FormMonthPicker.js